'use strict';

var ActionTypes = require('../constants/ActionTypes'),
    ServiceTypes = require('../constants/ServiceTypes'),
    AppDispatcher = require('../AppDispatcher'),
    InvitationStore = require('../stores/InvitationStore'),
    FormActionCreators = require('../actions/FormActionCreators'),
    NotificationActionCreators = require('../actions/NotificationActionCreators'),
    Messages = require('../constants/NotificationMessages');

var InvitationServerActionCreators = {
  handleInvitationsPage(err, response) {
    AppDispatcher.handleServerAction({
      type: err ? ActionTypes.REQUEST_INVITATIONS_ERROR : ActionTypes.REQUEST_INVITATIONS_SUCCESS,
      response: response
    });

    if (err) {
      console.error(err);
    }
  },

  handleSocialFriendsPage(err, response, serviceType) {
    AppDispatcher.handleServerAction({
      type: err ? ActionTypes.REQUEST_SOCIAL_FRIENDS_ERROR : ActionTypes.REQUEST_SOCIAL_FRIENDS_SUCCESS,
      serviceType: serviceType,
      response: response
    });

    if (err) {
      console.error(err);
    }
  },

  handleResendInvite(err, response) {
    AppDispatcher.handleServerAction({
      type: err ? ActionTypes.RESEND_INVITE_ERROR : ActionTypes.RESEND_INVITE_SUCCESS,
      response: response
    });

    if (err) {
      console.error(err);
    } else {
      NotificationActionCreators.showNotification(Messages.INVITE_SENT);
    }
  },

  handleSendInvite(err, response) {
    AppDispatcher.handleServerFormAction({
      type: err ? ActionTypes.SEND_INVITE_ERROR : ActionTypes.SEND_INVITE_SUCCESS,
      response: response,
      err: err
    });

    if (err) {
      console.error(err);
    } else {
      var inviteId = response.result,
          invite = InvitationStore.get(inviteId);

      FormActionCreators.resetForm();

      if (invite.serviceType === ServiceTypes.FACEBOOK) {
        // TODO: do it right
        var FacebookActionCreators = require('../actions/FacebookActionCreators');
        FacebookActionCreators.sendFacebookInvite(invite);
      } else {
        var InvitationActionCreators = require('../actions/InvitationActionCreators');
        InvitationActionCreators.requestInvitationsPage();
        NotificationActionCreators.showNotification(Messages.INVITE_SENT);
      }
    }
  },

  handleUpdateInvite(err, response) {
    AppDispatcher.handleServerFormAction({
      type: err ? ActionTypes.UPDATE_INVITE_ERROR : ActionTypes.UPDATE_INVITE_SUCCESS,
      response: response,
      err: err
    });

    if (err) {
      console.error(err);
    } else {
      var InvitationActionCreators = require('../actions/InvitationActionCreators');
      InvitationActionCreators.requestInvitationsPage();
      NotificationActionCreators.showNotification(Messages.INVITE_SENT);
    }
  }
};

module.exports = InvitationServerActionCreators;


/** WEBPACK FOOTER **
 ** ./actions/InvitationServerActionCreators.js
 **/